// Core Imports
import { api } from '@/core/lib/api'
import type { TResponse } from '@/core/types/axios'
import type { TAdminListParams } from '@/core/lib/table-query'

// Module Imports
import { categoryEndpoints } from '@/modules/category/category.constants'
import type {
  TCategory,
  TCategoryDetail,
  TCreateCategoryRequest,
  TDeleteCategoryRequest,
  TEditCategoryRequest,
  TToggleCategoryVisibilityRequest,
} from '@/modules/category/category.types'

export async function getAllCategories(): Promise<TCategory[]> {
  const response = await api.get<TResponse<TCategory[]>>(categoryEndpoints.all)

  return response.data.data
}

export async function getCategoryList(
  params: TAdminListParams
): Promise<TResponse<TCategory[]>> {
  const response = await api.get<TResponse<TCategory[]>>(
    categoryEndpoints.list(params)
  )

  return response.data
}

export async function createCategory(
  payload: TCreateCategoryRequest
): Promise<TCategoryDetail> {
  const response = await api.post<TResponse<TCategoryDetail>>(
    categoryEndpoints.create,
    payload
  )

  return response.data.data
}

export async function editCategory(
  payload: TEditCategoryRequest
): Promise<TCategoryDetail> {
  const { id, ...body } = payload
  const response = await api.patch<TResponse<TCategoryDetail>>(
    categoryEndpoints.edit(id),
    body
  )

  return response.data.data
}

export async function toggleCategoryVisibility(
  payload: TToggleCategoryVisibilityRequest
): Promise<TCategoryDetail> {
  const response = await api.patch<TResponse<TCategoryDetail>>(
    categoryEndpoints.visibility(payload.id),
    { is_public: payload.is_public }
  )

  return response.data.data
}

export async function deleteCategory(
  payload: TDeleteCategoryRequest
): Promise<void> {
  await api.delete(
    categoryEndpoints.delete(payload.id, payload.delete_questions)
  )
}
